export const getDefaultDevice = (data: any) => {
  if (data?.onDesktop && data?.onMobile) return "mobileDesktop";
  if (data?.onDesktop) return "desktop";

  return "mobile";
};
